import { ActivityItem } from "api/admin/activities";
import i18n from "../i18n";

// format full name as "firstname lastname"
const formatNameFirstLast = ({ firstName, lastName }: { firstName: string, lastName: string }) => `${firstName} ${lastName}`;

// generate text for an activity item (props @ Florian)
const generateTextForActivityItem = (item: ActivityItem, formatName = formatNameFirstLast) => {
    const { changes } = item;
    if (item.activityType === "active") {
        const actor = formatName(item.user);
        const participantName = item.participant && formatName(item.participant.user);
        if (changes.id !== undefined) {
            return i18n.bookingCreated(actor);
        }
        if (changes.isCancellableForFree !== undefined) {
            return i18n.cancellationRequested(actor);
        }
        if (changes.bookingType === "standard") {
            return i18n.bookingTransformed(actor, i18n.bookingTypes[changes.bookingType]);
        }
        if (changes.invitationStatus === "pending" && participantName) {
            return i18n.participantAdded(actor, participantName);
        }
        if (changes.startDate || changes.duration) {
            return i18n.bookingTimeChanged(actor);
        }
        if (changes.description || changes.detailsDescription) {
            return i18n.bookingDescChanged(actor);
        }
        if (changes.participationRequestType) {
            return i18n.participantRequestTypeChanged(actor, changes.participationRequestType === "invite-only");
        }
        if (changes.bookingStatus === "cancelled") {
            return i18n.bookingCancelled(actor);
        }
        if (changes.checkInStatus === "checked-in") {
            return i18n.bookingCheckedIn(actor);
        }
        if (changes.invitationStatus && changes.type === "invitation") {
            return i18n.invitationStatusChanged(actor, changes.invitationStatus === "accepted");
        }
        if (changes.invitationStatus && changes.type === "participation-request") {
            const { invitationStatus } = changes;
            return i18n.participationRequested(actor, invitationStatus === "accepted");
        }
        if (participantName && changes.type === "participation-request-answered") {
            const { invitationStatus } = changes;
            return i18n.participationRequestAnswered(actor, participantName, invitationStatus === "accepted");
        }
        if (changes.type === "participation-request-cancelled" && changes.userFullName) {
            return i18n.participationRequestCancelled(changes.userFullName);
        }
        if (participantName && changes.type === "other") {
            const { invitationStatus } = changes;
            return (invitationStatus === "declined")
                ? i18n.participantRemoved(actor, participantName)
                : i18n.otherChanged(actor, participantName, i18n.invitationStatus[invitationStatus]);
        }
    } else if (item.activityType === "passive") {
        if (changes.bookingStatus === "cancelled") {
            return i18n.bookingCancelledPassive;
        }
        if (changes.bookingStatus === "pending") {
            return i18n.bookingPending;
        }
        if (changes.bookingStatus === "final") {
            return i18n.bookingFinalized;
        }
    }

    // same for passive / active
    if (item.participant && changes.invitationStatus && changes.type === "other") {
        const participantName = `${item.participant.user.firstName} ${item.participant.user.lastName}`;
        return i18n.otherChangedPassive(participantName, i18n.invitationStatus[changes.invitationStatus]);
    }

    // fallback solution
    const subject = item.user ? `${item.user.firstName} ${item.user.lastName}` : undefined;
    const getObjectForKey = (key: string) => (item.participant ? `${item.participant.user.firstName} ${item.participant.user.lastName}'s ${key}` : `${key}`);
    return Object.keys(changes).map((key) => {
        const value = changes[key];
        return subject ? i18n.fallbackSolution(subject, key, value) : i18n.fallbackSolutionPassive(getObjectForKey(key), value);
    }).join("\n");
};

export default generateTextForActivityItem;
